import { useUserStore } from "@/store/user";
import { usePopupStore } from "@/store/popup.ts";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";
import { POPUP_MANUAL_CANCELLATION } from "@/utils/variables.ts";

export default async ({ to, pinia, redirect }: MiddlewareInterface) => {
  if (to.query.cancellation_token && useUserStore(pinia).isPremium) {
    usePopupStore(pinia).show(POPUP_MANUAL_CANCELLATION, { token: to.query.cancellation_token });

    delete to.query.cancellation_token;
    redirect(to);
  }
};
